import styled, { keyframes } from 'styled-components';

/* ── paleta do design system ── */
const TEAL = 'var(--teal)';
const TEAL_TEXT = 'var(--teal-text, var(--teal))';
const TEAL_LIGHT = 'var(--teal-light)';
const TEAL_SOFT = 'var(--teal-soft)';
const GRAY_BG = 'var(--bg)';
const GRAY_LINE = 'var(--line)';
const GRAY_TEXT = 'var(--text-muted)';

const TEAL_GLOW = 'var(--teal-glow)';

const bp = { desktop: '1024px', tablet: '768px', mobile: '540px', small: '420px' };

const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
`;
const expand = keyframes`
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  overflow-x: hidden;
  background:
    radial-gradient(1200px 400px at 50% -120px, var(--bg-glow) 0%, transparent 70%),
    ${GRAY_BG};
  padding: 16px;

  > h2 {
    width: 100%;
    max-width: 760px;
    margin: 4px 0 12px;
    font-size: 20px;
    font-weight: 800;
    color: ${TEAL_TEXT};
    display: flex;
    align-items: center;
    gap: 9px;
    &::before { content: '📚'; }
  }
  @media (max-width: ${bp.tablet}) { padding: 12px; }
  @media (max-width: ${bp.mobile}) { padding: 8px; > h2 { font-size: 17px; } }
`;

/* ── busca ── */
export const Search = styled.div`
  width: 100%;
  max-width: 760px;
  box-sizing: border-box;
  margin-bottom: 12px;
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 14px;
  padding: 16px 18px;
  animation: ${fadeUp} 0.35s ease;
  @media (max-width: ${bp.mobile}) { padding: 14px; }
`;

export const FormSearch = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  label { color: ${GRAY_TEXT}; font-weight: 700; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px; margin: 0 0 7px 2px; }
`;

export const AreaEmp = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  &::before {
    content: '🔍';
    position: absolute;
    left: 12px;
    font-size: 14px;
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const InputEmp = styled.input`
  height: 44px;
  width: 100%;
  padding: 0 12px 0 36px;
  border: 1px solid ${GRAY_LINE};
  border-radius: 11px;
  font-size: 15px;
  font-family: inherit;
  background: ${GRAY_BG};
  transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;
  box-sizing: border-box;
  &:focus {
    outline: none;
    background: var(--surface);
    border-color: ${TEAL_LIGHT};
    box-shadow: 0 0 0 3px rgba(10, 90, 115, 0.12);
  }
`;

/* ── lista ── */
export const List = styled.div`
  width: 100%;
  max-width: 760px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 14px;
  padding: 16px 18px;
  animation: ${fadeUp} 0.35s ease backwards;

  > p {
    text-align: center;
    color: ${GRAY_TEXT};
    font-size: 14px;
    padding: 30px 12px;
    border: 1px dashed ${GRAY_LINE};
    border-radius: 11px;
    background: ${GRAY_BG};
  }
  @media (max-width: ${bp.mobile}) { padding: 14px; }
`;

export const DivAddEmp = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: 6px;
`;

export const DivNewEmp = styled.div`
  display: flex;
  justify-content: flex-end;
  @media (max-width: ${bp.mobile}) { width: 100%; }
`;

/* item: faixa colorida à esquerda + chip da inicial */
export const Emp = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 15px;
  border: 1px solid ${GRAY_LINE};
  border-left: 4px solid var(--accent, ${TEAL});
  border-radius: 11px;
  background: var(--surface);
  transition: background .15s ease, transform .12s ease, box-shadow .15s ease;
  animation: ${fadeUp} 0.3s ease backwards;
  &:hover {
    background: ${GRAY_BG};
    transform: translateX(3px);
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.05);
  }
  @media (max-width: ${bp.mobile}) { padding: 11px 13px; }
`;

export const EmpMain = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
`;

export const MatterIcon = styled.span`
  width: 38px;
  height: 38px;
  min-width: 38px;
  border-radius: 10px;
  background: var(--accent, ${TEAL});
  color: var(--text);
  font-size: 15px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
`;

export const Span = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media (max-width: ${bp.mobile}) { font-size: 14px; }
`;

/* ── botões ── */
export const Btt02 = styled.button`
  background: ${TEAL};
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  box-shadow: 0 2px 8px ${TEAL_GLOW};
  transition: filter .15s ease, transform .12s ease;
  &:hover { filter: brightness(1.06); transform: translateY(-1px); }
  &:active { transform: translateY(0); }
  @media (max-width: ${bp.mobile}) { padding: 9px 16px; }
`;

export const AddBtn = styled(Btt02)`
  &::before { content: '＋'; font-size: 16px; }
  @media (max-width: ${bp.mobile}) { width: 100%; }
`;

/* botão "Editar" discreto no item colorido */
export const EditBtn = styled.button`
  background: var(--surface);
  color: ${TEAL_TEXT};
  border: 1px solid ${GRAY_LINE};
  border-radius: 9px;
  padding: 7px 14px;
  cursor: pointer;
  font-size: 12.5px;
  font-weight: 700;
  font-family: inherit;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: background .15s ease, transform .12s ease;
  &::before { content: '✏️'; }
  &:hover { background: ${TEAL_SOFT}; transform: translateY(-1px); }
`;

/* botão "Editar ordem" (abre o modo de reordenação) */
export const ReorderBtn = styled(Btt02)`
  background: var(--surface);
  color: ${TEAL_TEXT};
  border: 1px solid ${GRAY_LINE};
  box-shadow: none;
  &::before { content: '↕'; font-size: 15px; }
  &:hover { background: ${TEAL_SOFT}; filter: none; }
  @media (max-width: ${bp.mobile}) { width: 100%; }
`;

/* alça de arrastar */
export const DragHandle = styled.span`
  font-size: 18px;
  line-height: 1;
  color: ${GRAY_TEXT};
  cursor: grab;
  &:active { cursor: grabbing; }
`;

/* posição numérica / etiqueta "fixa" */
export const OrderPos = styled.span`
  min-width: 36px;
  font-size: 13px;
  font-weight: 800;
  color: ${TEAL_LIGHT};
  flex-shrink: 0;
`;

/* dica do modo de reordenação */
export const ReorderHint = styled.p`
  margin: 0 0 4px;
  font-size: 13px;
  color: ${GRAY_TEXT};
  background: ${TEAL_SOFT};
  border: 1px dashed ${TEAL_LIGHT};
  border-radius: 10px;
  padding: 10px 12px;
`;

export const LoadingSpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
`;

/* ── modal de edição ── */
export const EditContainer = styled.div`
  position: fixed;
  inset: 0;
  backdrop-filter: blur(3px);
  background: rgba(0, 30, 38, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 16px;
  animation: ${fadeIn} 0.15s ease;
  @media (max-width: ${bp.mobile}) { padding: 0; align-items: flex-end; }

  & > div {
    background: var(--surface);
    padding: 26px 24px;
    border-radius: 16px;
    box-shadow: 0 18px 50px rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
    max-width: 460px;
    box-sizing: border-box;
    animation: ${expand} 0.2s ease;
    @media (max-width: ${bp.mobile}) { border-radius: 18px 18px 0 0; max-width: 100%; }
  }

  h3 {
    margin: 0;
    font-size: 18px;
    color: ${TEAL_TEXT};
    display: flex;
    align-items: center;
    gap: 8px;
    &::before { content: '✏️'; }
  }

  & > div > :not(h3):not(input):not(div) {
    font-size: 13px;
    font-weight: 700;
    color: ${GRAY_TEXT};
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }

  input {
    padding: 12px 14px;
    font-size: 15px;
    font-family: inherit;
    border: 1px solid ${GRAY_LINE};
    border-radius: 11px;
    outline: none;
    background: ${GRAY_BG};
    transition: border-color .15s ease, box-shadow .15s ease;
    &:focus { border-color: ${TEAL_LIGHT}; box-shadow: 0 0 0 3px rgba(10, 90, 115, 0.12); background: var(--surface); }
  }
`;

export const BoxButtonEdit = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 4px;

  /* o 2º botão (Cancelar) fica secundário */
  button:last-child {
    background: var(--surface-2);
    color: ${GRAY_TEXT};
    border: 1px solid ${GRAY_LINE};
    box-shadow: none;
  }
  @media (max-width: ${bp.small}) {
    flex-direction: column-reverse;
    button { width: 100%; }
  }
`;